/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/schedulerobjects/scheduler_reporting.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SchedulerobjectsSchedulingReport
 */
export interface SchedulerobjectsSchedulingReport {
    /**
     * 
     * @type {string}
     * @memberof SchedulerobjectsSchedulingReport
     */
    report?: string;
}

export function SchedulerobjectsSchedulingReportFromJSON(json: any): SchedulerobjectsSchedulingReport {
    return SchedulerobjectsSchedulingReportFromJSONTyped(json, false);
}

export function SchedulerobjectsSchedulingReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchedulerobjectsSchedulingReport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'report': !exists(json, 'report') ? undefined : json['report'],
    };
}

export function SchedulerobjectsSchedulingReportToJSON(value?: SchedulerobjectsSchedulingReport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'report': value.report,
    };
}

